export class QrefAction4936Model {
  id: string;
  description: string;

  constructor() {
  }
}

